import { sapApi } from "@/apis/interceptor"
import { IGetEmployeeByIdParams, IResponse, ISapSupplierDto, ISapSupplierResponseData, ISapSupplier, ISapSupplierPreview, ISapSupplierUpdateDto } from "@/types"

const createSupplierFormData = (dto: ISapSupplierDto): FormData => {
  const formData = new FormData()

  formData.append("employee_id", dto.employee_id)
  formData.append("fullname", dto.fullname)
  formData.append("level", dto.level)
  formData.append("department", dto.department)
  formData.append("type_of_request", dto.type_of_request)
  
  if (dto.note) {
    formData.append("note", dto.note)
  }

  formData.append("file", dto.file)

  if (dto.attachments_description) {
    formData.append("attachments_description", dto.attachments_description)
  }

  if (dto.attachments && dto.attachments.length > 0) {
    dto.attachments.forEach((file) => {
      formData.append("attachments", file)
    })
  }

  return formData
}

export const sapSuppliersService = {
  getSapSuppliers: async (params: IGetEmployeeByIdParams): Promise<IResponse<ISapSupplierResponseData>> => {
    const response = await sapApi.get<IResponse<ISapSupplierResponseData>>("/api/v1/suppliers/history", { params })
    return response.data
  },

  getSapSupplierByRecordId: async (recordId: string): Promise<IResponse<ISapSupplier>> => {
    const response = await sapApi.get<IResponse<ISapSupplier>>(`/api/v1/suppliers/${recordId}`)
    return response.data
  },

  updateSapSupplier: async (recordId: string, dto: ISapSupplierUpdateDto): Promise<IResponse<ISapSupplier>> => {
    const response = await sapApi.patch<IResponse<ISapSupplier>>(`/api/v1/suppliers/${recordId}`, dto)
    return response.data
  },

  getSapSupplierAttachmentUrl: async (recordId: string, fileKey: string): Promise<IResponse<{ url: string }>> => {
    const response = await sapApi.get<IResponse<{ url: string }>>(`/api/v1/suppliers/${recordId}/attachment`, {
      params: {
        file_key: fileKey,
      },
    })
    return response.data
  },

  createSapSupplier: async (dto: ISapSupplierDto): Promise<ISapSupplier> => {
    const formData = createSupplierFormData(dto)

    const response = await sapApi.post<ISapSupplier>("/api/v1/suppliers", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  previewSupplier: async (file: File): Promise<ISapSupplierPreview> => {
    const formData = new FormData()
    formData.append("file", file)

    const response = await sapApi.post<ISapSupplierPreview>("/api/v1/suppliers/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },
}
